<div class="padding flex column fix-width">
	<b>Pickup products</b>
	<img class="pickup-image margin-bottom-small margin-top-small" src="assets/pickup.png" alt="Pickup ready" />

	<div class="bg-green padding-small white margin-bottom-small">
		<i class="fa-solid fa-check margin-right-smallest"></i>
		Order is ready for pickup!
	</div>

	<div>
		Please pick up your products at the following warehouse:
		@if (data.warehouse) {
		<div class="primary-dark bold margin-top-smallest">
			{{ data.warehouse.code }} - {{ data.warehouse.description }}
		</div>
		<div class="primary-dark bold margin-top-smallest">{{ data.warehouse.address }}</div>
		}
	</div>

	<div class="flex column end full-width margin-top">
		<div class="flex center">
			<button (click)="close()" class="stroked">
				<i class="fa-solid fa-check"></i>
				Close
			</button>
		</div>
	</div>
</div>